// extracted by mini-css-extract-plugin
export default {"logo":"SplashScreen_logo__dKsv3","pulse":"SplashScreen_pulse__QZQz1","overlay":"SplashScreen_overlay__kEe4W"};